var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscript"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.5 7.8125C2.5 6.93886 2.5 6.50204 2.64273 6.15747C2.83303 5.69804 3.19804 5.33303 3.65747 5.14273C4.00204 5 4.43886 5 5.3125 5H12.6875C13.5611 5 13.998 5 14.3425 5.14273C14.802 5.33303 15.167 5.69804 15.3573 6.15747C15.5 6.50204 15.5 6.93886 15.5 7.8125M6.1875 20.0004H11.8125M9 5V20.0004M19.5 12.9998L21.5 12V20.0004",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscript);
export default __webpack_public_path__ + "static/media/subscript.d043451da71afe5bf026702f4b6f2774.svg";
export { ForwardRef as ReactComponent };